module.exports = __webpack_public_path__ + "img/header-banner.7df0f849.png";